export default __webpack_public_path__ + "static/media/mSafety_logo_white.03bf8269.png";